/**
 * Row Style Formatter.
 * @param {*} row
 * @returns {*}
 */
window.rowStyleFormatter = function(row) {
    if (row.rowstyle) {
        return {
            classes: row.rowstyle
        };
    }
    return {};
};
